import { useEffect, useState } from 'react';
import { useUserStore } from '../../../Auth/stores/authStore';
import { flashcardService } from '../../queries';

const useFlashcardByDisciplineUuid = ({
  disciplineUuid,
}: {
  disciplineUuid: string;
}) => {
  const { user } = useUserStore();
  const memoryUserUuid = user?.memoryUserUuid;

  const [isLoading, setIsLoading] = useState(false);
  const [flashcards, setFlashcards] = useState<IFlashcardByDisciplineResponse>(
    {} as IFlashcardByDisciplineResponse
  );

  const fetchFlashcards = async ({
    disciplineUuid,
  }: {
    disciplineUuid?: string;
  }) => {
    const disciplineUuidToFetch = disciplineUuid || disciplineUuid;
    if (!memoryUserUuid || !disciplineUuidToFetch) return;

    setIsLoading(true);
    try {
      const response = await flashcardService.listByDiscipline(
        memoryUserUuid,
        disciplineUuidToFetch
      );
      setFlashcards(response);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchFlashcards({ disciplineUuid });
  }, [memoryUserUuid, disciplineUuid]);

  return { flashcards, isLoading, fetchFlashcards };
};

export default useFlashcardByDisciplineUuid;
